import axios from '../../../shared/http/customAxios';

export default class PartnerRepository {
	async get() {
		const result = await axios().get('/v1/partners');
		return result;
	}
}
